// extracted by mini-css-extract-plugin
export var brandPrimary = "index-module--brandPrimary--ef9db";
export var link = "index-module--link--ab307";
export var primary = "index-module--primary--c1fad";